export const useArrangeSubmit = (applyArranges: () => Promise<void>) => {
  const onFinish = async () => {
    // TODO: make close
    await applyArranges();
  };

  return { onFinish };
};
